import React from 'react';
import classnames from 'classnames';

import Part from './Part';
import VideoModal from './VideoModal';
import styles from './PartsPicker.scss';
import { CdnContext } from '../context';

class PartsPicker extends React.Component {
    state = {
        videoModalOpen: false,
    };

    toggleModal = () => {
        this.setState({
            videoModalOpen: !this.state.videoModalOpen,
        });
    };

    render() {
        const { parts } = this.props;
        return (
            <React.Fragment>
                <div className={styles.root}>
                    {parts.map((part, index) => (
                        <Part
                            key={part.slug}
                            className={classnames(
                                styles.part,
                                `part-${index + 1}`
                            )}
                            {...part}
                            subTitle={`Deel ${index + 1}`}
                        />
                    ))}
                    <div className={classnames(styles.part, styles.testinomy)}>
                        <div onClick={this.toggleModal}>
                            <div>
                                <CdnContext.Consumer>
                                    {cdn => (
                                        <img
                                            src={`${cdn}assets/images/part-icons/6.png`}
                                            alt=""
                                            className="part-icon"
                                        />
                                    )}
                                </CdnContext.Consumer>
                                <h6 className="PartsPicker__subHeading___1giqG">
                                    Filmpje
                                </h6>
                                <h5 className="PartsPicker__heading___CNGce">
                                    Het verhaal van Femke
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <VideoModal
                    onClose={this.toggleModal}
                    open={this.state.videoModalOpen}
                    src="https://player.vimeo.com/video/289433169"
                />
            </React.Fragment>
        );
    }
}

export default PartsPicker;



// WEBPACK FOOTER //
// ./src/components/PartsPicker.js